<div class="selected-files">
  @for (file of attachments(); track file.name + file.lastModified; let index = $index) {
    <div class="selected-file">
      @if (previewUrl()(file); as url) {
        <button
          class="selected-file-thumbnail"
          type="button"
          [attr.aria-label]="labels().previewAttachment + ': ' + file.name"
          (click)="openAttachment(file, $event)"
        ><img [src]="url" alt="" (error)="imageFailed.emit(file)" /></button>
      } @else if (isSpreadsheet(file)) {
        <button
          class="selected-file-thumbnail selected-file-document"
          type="button"
          [attr.aria-label]="labels().previewAttachment + ': ' + file.name"
          (click)="openAttachment(file, $event)"
        ><ng-icon name="page" size="19" /></button>
      } @else {
        <span class="selected-file-icon"><ng-icon name="page" size="17" /></span>
      }
      <span class="selected-file-copy">
        <strong [title]="file.name">{{ file.name }}</strong>
        <small>{{ formatFileSize(file) }}</small>
      </span>
      <button
        class="selected-file-remove"
        type="button"
        (click)="attachmentRemoved.emit(index)"
        [attr.aria-label]="labels().removeFile + ': ' + file.name"
      ><ng-icon name="xmark" size="17" /></button>
    </div>
  }
  @if (!audioRecorded()) {
    @if (audio(); as audioFile) {
      <div class="selected-file">
        <span class="selected-file-icon"><ng-icon name="musicDoubleNote" size="17" /></span>
        <span class="selected-file-copy">
          <strong [title]="audioFile.name">{{ audioFile.name }}</strong>
          <small>{{ formatFileSize(audioFile) }}</small>
        </span>
        <button
          class="selected-file-remove"
          type="button"
          (click)="audioRemoved.emit()"
          [attr.aria-label]="labels().removeFile + ': ' + audioFile.name"
        ><ng-icon name="xmark" size="17" /></button>
      </div>
    }
  }
  @if (video(); as videoFile) {
    <div class="selected-file">
      <span class="selected-file-icon"><ng-icon name="mediaVideo" size="17" /></span>
      <span class="selected-file-copy">
        <strong [title]="videoFile.name">{{ videoFile.name }}</strong>
        <small>{{ formatFileSize(videoFile) }}</small>
      </span>
      <button
        class="selected-file-remove"
        type="button"
        (click)="videoRemoved.emit()"
        [attr.aria-label]="labels().removeFile + ': ' + videoFile.name"
      ><ng-icon name="xmark" size="17" /></button>
    </div>
  }
</div>
